// extracted by mini-css-extract-plugin
export default {"bar":"styles__bar___De7rG mixins__clearfix___YpR0o"};